/**
 * Decodes HTML entities in a string.
 * This is used after sanitizing HTML to convert entities like &amp; to & for display.
 * @param {string} encodedString - String potentially containing HTML entities
 * @returns {string} String with entities decoded
 */
export function decodeHtmlEntities(encodedString) {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = encodedString;
  return textArea.value;
}
